import type { Text } from 'slate';

import type { StrongMdNode, ReadmeInline } from '@ui/MarkdownEditor/types';

export const deserialize = (node: StrongMdNode, deeper: (n: StrongMdNode) => (ReadmeInline | Text)[]) => {
  const decorator = '**';
  return [{ text: decorator }, ...deeper(node), { text: decorator }];
};
